import { CreditStatus } from '@/helpers/entities/enums/v2/CreditStatus';
import { CreditPaymentType } from '@/helpers/entities/enums/v2/CreditPaymentType';
import { enumValueNormalizer } from '@/helpers/enum_value_normalizer';
import moment from 'moment';
export class CreditModel {
    constructor(payload) {
        this.status = CreditStatus.Pending;
        Object.assign(this, payload);
    }
    /**
     * Humanized Created At Date
     * @author Angelo David <adavid@gorated.ph>
     * @since Version {0.45.0}
     *
     * @return {string} format: January 19, 2021 3:53 PM
     */
    get formattedCreatedAt() {
        const date = new Date(this.createdAt);
        return moment(date).format('LLL');
    }
    /**
     * Humanized Credit Status
     * @author Angelo David <adavid@gorated.ph>
     * @since Version {0.45.0}
     *
     * @return {string}
     */
    get humanizedStatus() {
        return enumValueNormalizer(this.status);
    }
    /**
     * Humanized Payment Type
     * @author Angelo David <adavid@gorated.ph>
     * @since Version {0.45.0}
     *
     * @return {string}
     */
    get humanizedPaymentType() {
        if (this.paymentType === CreditPaymentType.Bank) {
            return 'Bank Deposit';
        }
        if (this.paymentType === CreditPaymentType.BillEase) {
            return 'BillEase';
        }
        if (this.paymentType === CreditPaymentType.BPI) {
            return this.paymentType.toUpperCase();
        }
        if (this.paymentType === CreditPaymentType.GCash) {
            return 'GCash';
        }
    }
}
